import { render } from "./PerbangdinganKutipanBulan.vue?vue&type=template&id=331d49fb"
import script from "./PerbangdinganKutipanBulan.vue?vue&type=script&lang=js"
export * from "./PerbangdinganKutipanBulan.vue?vue&type=script&lang=js"

import "./PerbangdinganKutipanBulan.vue?vue&type=style&index=0&id=331d49fb&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__